import $ from "jquery";
class Horizontal {
  constructor(container) {
    this.container = $(container);
    this.setSize(window.orientation);
    window.addEventListener(
      "orientationchange",
      () => {
        // console.log(window.orientation);
        // 根据event.orientation|screen.orientation.angle等于0|180、90|-90度来判断横竖屏
        this.setSize(window.orientation);
      },
      false
    );
  }

  setSize(angle) {
    //页面初始化时横屏
    let ww = $(window).width();
    let wh = $(window).height();
    this.ishorizontal = ww > wh;
    this.winSize = this.ishorizontal ? [ww, wh] : [wh, ww];
    // this.container.css({
    //   marginLeft: -this.winSize[0] / 2,
    //   marginTop: -this.winSize[1] / 2,
    //   top: "50%",
    //   left: "50%",
    //   width: this.winSize[0],
    //   height: this.winSize[1],
    // });
    // var changeRotate = 0;
    // if(angle==0||angle==180){
    //   changeRotate = 90;
    // }
    // else{
    //   changeRotate = 0;
    // }
    window.curAngle = 0;
    // css3Animate.set(this.container, {
    //   rotate:changeRotate,
    // });
  }
}
export default Horizontal;
